<div class="filter-nav bg-primary overflow-visible " [ngClass]="sidebar ? 'sticky' : ''">
  <div class="container visible-xs-filter-bar">
    <div class="d-flex justify-content-between">
      <div class="d-flex">
        <div class="strong text-white  p-2 text-nowrap">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
        <div class="mr-2">
         <ng-select [items]="ports" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom" groupBy="ports"
             [selectableGroup]="false"
            [closeOnSelect]="true" placeholder="{{ 'home.productHeader.SelectPorts' | cxTranslate }}" bindValue="id"
            [(ngModel)]="selectedPort" notFoundText="{{'home.productHeader.NoItemsFound' | cxTranslate }}">
            <ng-template ng-multi-label-tmp>
              <span class="filter-count pl-2 text-black">{{selectedPort.length}}x {{ 'home.productHeader.SelectedPortstype' | cxTranslate }}</span>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
              <input type="checkbox" /><span class="ff-semibold"> {{ 'home.productHeader.Ports' | cxTranslate }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <div (pointerdown)="getPortFacets(item)">
              <input  (pointerdown)="getPortFacets(item)" *ngIf="item.name!==undefined && item.name!==''" id="{{item.id}}" type="checkbox"
              [ngModel]="item$.selected" [checked]="item.selected" /> <span (pointerdown)="getPortFacets(item)">{{item.name}}</span>
            </div>  
            </ng-template>
          </ng-select>  

        </div>
        <div class="mr-2">
          <ng-select [items]="productTypes" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
             groupBy="productType"
            placeholder="{{ 'home.productHeader.SelectProductTypes' | cxTranslate }}" [selectableGroup]="false"
            [closeOnSelect]="true" bindValue="id" [(ngModel)]="selectedProductType"
            notFoundText="{{'home.productHeader.NoItemsFound' | cxTranslate }}">
            <!-- <ng-template ng-multi-label-tmp>
              <span class="ng-placeholder">{{selectedProductType.length}}x {{ 'home.productHeader.SelectedTypes' |
                cxTranslate }}</span>
            </ng-template> -->
            <ng-template ng-multi-label-tmp>
              <span class="filter-count pl-2 text-black">{{selectedProductType.length}}x {{ 'home.productHeader.SelectedTypestypes' | cxTranslate }}</span>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index"
              class="dropdown-ng-template">
              <input type="checkbox" /> <span class="ff-semibold">{{ 'home.productHeader.ProductTypes' | cxTranslate
                }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
             <div (pointerdown)="getTypeFacets(item)">
              <input (pointerdown)="getTypeFacets(item)" *ngIf="item.name!==undefined && item.name!==''" id="{{item.id}}" [ngModel]="item$.selected" [checked]="item.selected"  type="checkbox"
                 /> <span (pointerdown)="getTypeFacets(item)">{{item.name}}</span>
              </div> 
            </ng-template>
          </ng-select>
        </div>
        <div class="mr-2">
          <ng-select #testselect [items]="productsList" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
            groupBy="product"
            placeholder="{{ 'home.productHeader.SelectProducts' | cxTranslate }}" [selectableGroup]="false"
            [closeOnSelect]="true" bindValue="id" [(ngModel)]="selectedProduct"
            notFoundText="{{'home.productHeader.NoItemsFound' | cxTranslate }}">
            <!-- <ng-template ng-multi-label-tmp>
              <span class="ng-placeholder text-black">{{selectedProduct.length}}x {{
                'home.productHeader.SelectedProducts' | cxTranslate }}</span>
            </ng-template> -->
            <ng-template ng-multi-label-tmp>
              <span class="filter-count pl-2 text-black">{{selectedProduct.length}}x {{'home.productHeader.SelectedProductsTypes' | cxTranslate }}</span>
            </ng-template>

            <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index"
              class="dropdown-ng-template">
              <input type="checkbox" /><span class="ff-semibold"> {{ 'home.productHeader.Products' | cxTranslate
                }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div (pointerdown)="getProductsFacet(item)">
               <input (pointerdown)="getProductsFacet(item)" *ngIf="item.name!==undefined && item.name!==''" id="{{item.id}}" [ngModel]="item$.selected" [checked]="item.selected"  type="checkbox"
                  /> <span (pointerdown)="getProductsFacet(item)">{{item.name}}</span>
               </div> 
             </ng-template>
            <!-- <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <input *ngIf="item.name!==undefined && item.name!==''" id="{{item.id}}" type="checkbox"
              [ngModel]="item$.selected" [checked]="item.selected"/> {{item.name}}
            </ng-template> -->
          </ng-select>
        </div>
        
          <div *ngIf="showClear">
            <button type="button" class="btn btn-warning clear-text " (click)="clearAllFilter()">{{
              'home.productHeader.ClearFilter' | cxTranslate }}</button>
          </div>

        
      </div>
      <div class="mr-2 search-section-col">
        <div class="search-section-div">
          <div class="input-group">
            <input class="form-control form-control-lg border rounded-pill input-field" type="search"
              (keypress)="omit_special_char($event)" [(ngModel)]="searchInput" (input)="searchQuote(searchInput)"
              placeholder="{{ 'home.productHeader.SearchProduct' | cxTranslate }}">
            <span class="input-group-append">
              <button name='searchbuttondesktop'
                class="btn btn-outline-secondary btnUpgrade rounded-pill border-0 input-field bg-white border-start-0 border-bottom-0 border ms-n5"
                type="button">
                <i class="fa fa-search pe-none"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container hidden-xs-filter-bar">
    <div class="row">
      <div class="w-100">
        <div class="filter-select-div-mobile pl-4">
          <div class="input-group">
            <input class="form-control form-control-lg border rounded-pill input-field" type="search"
              (keypress)="omit_special_char($event)" [(ngModel)]="searchInput" (input)="searchQuote(searchInput)"
              placeholder="{{ 'home.productHeader.SearchProduct' | cxTranslate }}">
            <span class="input-group-append">
              <button name='searchbuttonfilter' class="
                    btn
                    rounded-pill
                    border-0
                    input-field
                    border-start-0 border-bottom-0 border
                    ms-n5
                  " type="button">
                <i class="fa fa-search mobbar mb-3"></i>
              </button>
              <div class='hidden-xs-filter-bar vertical ml-4'></div>
              <div class='hidden-xs-filter-bar pr-2 pl-4' (click)='filtersidebar()'>
                <img class="ml-1" src="./images/white-filter.svg"><sup class="pl-2 pr-2 pt-1 pb-1"
                  *ngIf='length'>{{length}}</sup>
                <div class="ff-semibold fs-10 d-flex align-items-center text-white Filternew">{{ 'home.filter.filters' | cxTranslate }}</div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="background">
      <div [ngClass]="sidebar ?'hide-mobile-filter-sidebar': 'mobile-filter-sidebar' " class="hidden-xs-filter-bar sidebar">
        <div class='sticky-top  d-flex justify-content-between p-3 border sticky'>
          <div class="fs-24 strong pl-1">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
          <div (click)="closebar();clearFilterDataMobile($event)"><img src="/images/sidebarcross.svg"
              alt=""> </div>
        </div>
        <div>
          <div>
            <div class="d-flex strong  pl-3 pt-3 pb-2">{{ 'home.filter.ports' | cxTranslate }}</div>
            <div *ngFor="let portData of ports; let i=index" class="ml-5  d-flex line-height">
              <label class="ff-normal" *ngIf="portData.name!==undefined && portData.name!==''">
                <input type="checkbox" [(ngModel)]="portData.selected" [value]="portData.id"
                  [checked]="portData.selected"
                  (change)="getFacetsMobile(portData)" />
                {{portData.name}}
              </label>
            </div>
          </div>
          <div class="d-flex strong  pl-3 pt-3 pb-2">{{ 'home.filter.productTypes' | cxTranslate }}</div>
          <div *ngFor="let productType of productTypes; let i=index" class="ml-5  d-flex line-height">
            <label class="ff-normal" *ngIf="productType.name!==undefined && productType.name!==''">
              <input type="checkbox" [(ngModel)]="productType.selected" [value]="productType.id"
                [checked]="productType.selected"
                (change)="getFacetsMobile(productType)" />
              {{productType.name}}
            </label>
          </div>
        </div>
        <div class="d-flex strong  pl-3 pt-3 pb-2">{{ 'home.filter.products' | cxTranslate }}</div>
        <div *ngFor="let productData of productsList; let i=index" class="ml-5  d-flex line-height">
          <label class="ff-normal" *ngIf="productData.name!==undefined && productData.name!==''">
            <input type="checkbox" [(ngModel)]="productData.selected" [value]="productData.id"
              [checked]="productData.selected" (change)="getFacetsMobile(productData)" />
            {{productData.name}}
          </label>
        </div>

        <div class="sticky-bottom p-4 border-top">
          <button class="btn btn-block btn-primary w-100" (click)="submitForm()">{{ 'home.contracts.seeResults' |
            cxTranslate}}</button>
          <button class='btn btn-block' (click)="clearFilterDataMobile($event);">{{ 'home.contracts.clearFilter' |
            cxTranslate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>